import { render, staticRenderFns } from "./jyr.vue?vue&type=template&id=9794c1c4&scoped=true"
import script from "./jyr.vue?vue&type=script&lang=js"
export * from "./jyr.vue?vue&type=script&lang=js"
import style0 from "./jyr.vue?vue&type=style&index=0&id=9794c1c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9794c1c4",
  null
  
)

export default component.exports